"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipWrapper = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const utils_1 = require("../../utils");
// for some browsers there might be a difference of 1-2px between
// offsetHeight and scrollHeight even when both present on a same line and practically the same.
const HEIGHT_OFFSET = 3;
const TooltipWrapper = ({ children, text }) => {
    const [disabled, setDisabled] = (0, react_1.useState)(true);
    const tooltipRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(() => {
        const onResize = (0, utils_1.debounce)(() => {
            const node = tooltipRef.current;
            if (node !== null) {
                const hasCut = node.offsetHeight + HEIGHT_OFFSET < node.scrollHeight;
                setDisabled(!hasCut);
            }
        }, 200);
        window.addEventListener('resize', onResize);
        onResize();
        return () => {
            window.removeEventListener('resize', onResize);
            onResize.cancel();
        };
    }, []);
    return (react_1.default.createElement(styled_1.StyledTooltip, { ref: tooltipRef, content: text || null, disabled: disabled }, children));
};
exports.TooltipWrapper = TooltipWrapper;
exports.TooltipWrapper.Title = styled_1.StyledTitle;
exports.TooltipWrapper.displayName = 'TableTooltipWrapper';
